import endpoints from "api/endpoints";
import axiosNeuron from "api/axios";

export async function getMachineLabelSubcategories({
  machine,
  q,
  ps,
  field,
}: {
  machine: number;
  q?: string;
  ps?: number;
  field?: string[];
}) {
  const url = endpoints.machines.labelSubcategories(machine);
  const params = {
    ps: ps || 9999,
    q,
    field,
  };

  try {
    const res = await axiosNeuron.get(url, { params });

    const response = {
      results: res.data,
    };

    return response;
  } catch (error) {
    if (error !== undefined) {
      throw error;
    }
  }
}
